import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@esgian/esgianui';

/**
 * Returns true when series is empty or every data point across all series has y === 0, y == null, or y is NaN.
 * Works with chart.js-style ({ data: [{x, y}] }), ApexCharts-style ({ data: [number] }),
 * and string values like "0.00".
 */
NoDataAvailable.hasNoData = function hasNoData(series) {
  if (!series?.length) return true;
  return series.every((s) => {
    const d = s.data;
    if (!d?.length) return true;
    return d.every((point) => {
      const y = typeof point === 'object' && point !== null ? point.y : point;
      if (y == null) return true;
      const num = Number(y);
      return Number.isNaN(num) || num === 0;
    });
  });
};

function NoDataAvailable({ height }) {
  return (
    <Box sx={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="body2" color="text.secondary">No data available</Typography>
    </Box>
  );
}

NoDataAvailable.propTypes = {
  height: PropTypes.string
};

NoDataAvailable.defaultProps = {
  height: '300px'
};

export default NoDataAvailable;
